export default __webpack_public_path__ + "static/media/128x128.b2474527.jpg";